import React, {useState, useEffect} from "react";
import {addressAddressDetails, deleteAddress, editAddressStreetZip, flagAddress, getDeleteUserList, getUserList, ReActiveUsers} from "../../services/adminServices";
import moment from "moment";
import CustomLoader from "../../CustomComponents/CustomLoader";
import {Autocomplete, TextField, CircularProgress, TableSortLabel, Tooltip} from "@mui/material";
import {sweetAlertQuestion, sweetAlerts} from "../../utils/sweet-alerts";
import {Skeleton} from "@mui/material";
import CustomRatingStar from "../../CustomComponents/CustomRatingStar";
import CustomUserName from "../../CustomComponents/CustomUserName";
import CustomIconButton from "../../CustomComponents/CustomIconButton";
import {fDate} from "../../utils/format-time";

import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Chip from "@mui/material/Chip";
import Badge from "@mui/material/Badge";
import {visuallyHidden} from "@mui/utils";

import {Table, Dropdown} from "antd";

import {getStatusBadge, truncateWords} from "../../utils/format-text";
import CustomPagination from "../../CustomComponents/CustomPagination";
import {useDispatch} from "react-redux";

const MyAddress = () => {
	const dispatch = useDispatch();
	const [filterStatus, setFilterStatus] = useState("all");
	const [sortBy, setSortBy] = useState("date-desc");

	const [field, setField] = useState(null);
	const [order, setOrder] = useState(null);

	const [list, setList] = useState([]);
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [totalRecode, setTotalRecode] = useState(0);
	const [loading, setLoading] = useState(true);

	const [loadingButtons, setLoadingButtons] = useState({});

	const [showDetailModal, setShowDetailModal] = useState(false);
	const [selectedAddress, setSelectedAddress] = useState(null);

	const getMockAddress = () => {
		setLoading(true);
		getDeleteUserList({
			page: page,
			pagesize: pageSize,
			sortBy: sortBy,
			status: filterStatus,
			field,
			order,
		})
			.then((res) => {
				setLoading(false);
				if (res?.status) {
					setList(res?.data?.list || []);
					setTotalRecode(res?.data?.totalCount || 0);
				}
			})
			.catch(() => {
				setList([]);
				setTotalRecode(0);
			});
	};

	useEffect(() => {
		getMockAddress();
	}, [page, pageSize]);

	useEffect(() => {
		setPage(1);
		getMockAddress();
	}, [filterStatus, field, order]);

	const handleReActive = async (id) => {
		sweetAlertQuestion("Are you sure you want to Reactivate this user?").then(async (result) => {
			if (result === "Yes") {
				try {
					await new Promise((resolve) => setTimeout(resolve, 500));
					const response = await ReActiveUsers({user_id: id});
					if (response && response.status === true) {
						sweetAlerts("success", "This user activated successfully");
						getMockAddress();
					} else {
						sweetAlerts("error", "Failed user activated. Please try again.");
					}
				} catch (error) {
					console.error("Error deleting address:", error);
					sweetAlerts("error", error || "Failed user activated. Please try again.");
				} finally {
				}
			}
		});
	};

	const columns = [
		{
			title: "User Name",
			dataIndex: "user_name",
			key: "user_name",
			width: "250px",
			sorter: true,
			render: (_, item) => <CustomUserName user={item} />,
		},
		{
			title: "User Email",
			dataIndex: "email",
			key: "email",
			width: "250px",
			sorter: true,
			render: (_, item) => <>{item?.email}</>,
		},
		{
			title: "Role",
			dataIndex: "role",
			key: "role",
			width: "250px",
			sorter: true,
			render: (_, item) => <>{item?.role ? item.role.charAt(0).toUpperCase() + item.role.slice(1).toLowerCase() : ""}</>,
		},
		{
			title: "Deactivated Date",
			dataIndex: "delete_at",
			key: "delete_at",
			width: "180px",
			align: "center",
			sorter: true,
			render: (_, item) => fDate(item?.delete_at),
		},
		{
			title: "Action",
			dataIndex: "Action",
			key: "Action",
			width: "100px",
			fixed: "right",
			align: "right",
			render: (_, item) => (
				<div className="table-actions mb-0 justify-content-end flex-row">
					<button
						className="btn-icon "
						title="Active User"
						onClick={(e) => {
							e.stopPropagation();
							handleReActive(item?.user_id);
						}}>
						<CustomIconButton type="active" />
					</button>
				</div>
			),
		},
	];

	return (
		<div className="">
			<div className="page-header">
				<h2>Deactivated Users</h2>
				<p>View and manage all deactivate users ({totalRecode} total)</p>
			</div>

			<div className="card">
				<Paper sx={{width: "100%", overflow: "hidden"}}>
					<Table
						// size="small"
						columns={columns}
						dataSource={list}
						pagination={false}
						showSorterTooltip={false}
						rowClassName={(record) => (record?.admin_flagged ? "row-flagged" : "")}
						scroll={{x: "max-content"}}
						style={{width: "100%", cursor: "pointer"}}
						onRow={(record) => ({
							onClick: () => {
								setSelectedAddress(record);
								setShowDetailModal(true);
							},
						})}
						onChange={(_, __, sorter) => {
							if (sorter?.field && sorter?.order) {
								setField(sorter?.field);
								setOrder(sorter?.order);
								setOrder(sorter?.order);
							} else {
								setField(null);
								setOrder(null);
							}
						}}
					/>

					{!loading && (
						<CustomPagination
							current={page}
							pageSize={pageSize}
							total={totalRecode}
							onChange={(e) => setPage(e)}
							scroll={{x: "max-content", y: 10 * 5}}
							onShowSizeChange={(p, e) => {
								setPage(p);
								setPageSize(e);
							}}
						/>
					)}
				</Paper>
			</div>

			{showDetailModal && selectedAddress && (
				<div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
					<div className="modal-content" onClick={(e) => e.stopPropagation()}>
						<div className="modal-header">
							<h3>Deactivated User Details</h3>
							<button className="modal-close" onClick={() => setShowDetailModal(false)}>
								×
							</button>
						</div>

						{console.log("selectedAddress", selectedAddress)}

						<div className="modal-body">
							<div className="detail-section">
								<h4>User Details</h4>
								<div className="detail-grid">
									<div className="detail-item">
										<span className="detail-label">User Name:</span>
										<span className="detail-value">{selectedAddress?.first_name + " " + selectedAddress?.last_name}</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">User Email:</span>
										<span className="detail-value">{selectedAddress?.email}</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">Role:</span>
										<span className="detail-value">{selectedAddress.role}</span>
									</div>
									<div className="detail-item">
										<span className="detail-label">Deactivated Date:</span>
										<span className="detail-value">{fDate(selectedAddress?.delete_at)}</span>
									</div>
								</div>
							</div>
						</div>

						<div className="modal-footer">
							<button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>
								Close
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default MyAddress;
// onRow={(record) => ({
// 	onClick: () => {
// 		// selectItemAction(record.key);
// 	},
// })}
